export default __webpack_public_path__ + "static/media/ag_1.ffea7661.wav";